import { type MCPServerInfo } from '../../types';

const GrafanaServer: MCPServerInfo = {
  serverId: 'GRAFANA',
  name: 'Grafana',
  slug: 'grafana',
  description:
    'Grafana MCP Server - Access dashboards, datasources, run PromQL/LogQL queries, manage alert rules, incidents, and more. Connect to your Grafana instance or Grafana Cloud.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/grafana/mcp-grafana',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'ghcr.io/grafana/mcp-grafana'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['grafanaUrl'],
    properties: {
      grafanaUrl: {
        type: 'string',
        description:
          'URL to your Grafana instance (e.g. http://localhost:3000 or https://myinstance.grafana.net)',
        sensitive: false
      },
      grafanaServiceAccountToken: {
        type: 'string',
        description:
          'Service account token for Grafana API authentication (recommended)',
        sensitive: true
      },
      grafanaUsername: {
        type: 'string',
        description: 'Grafana username (alternative to service account token)',
        sensitive: false
      },
      grafanaPassword: {
        type: 'string',
        description: 'Grafana password (use with grafanaUsername)',
        sensitive: true
      },
      grafanaOrgId: {
        type: 'string',
        description: 'Organization ID for multi-org Grafana instances',
        sensitive: false
      }
    }
  }
};

export default GrafanaServer;
